module.exports = __webpack_public_path__ + "static/media/motivation1.c09e3180.jpg";